/**
 * Nombres affichés à l'écran : toujours en français (virgule décimale, espace
 * insécable des milliers), quelle que soit la langue du navigateur.
 * T-262 (V-B4). Remplace `.toFixed(n)` et `.toLocaleString("fr-FR")` sans langue.
 *
 *   nombreFR(1234.5, 2)  → "1 234,50"
 *   nombreFR(46.5, 1)    → "46,5"
 *   nombreFR(null)       → "0"
 */
const formateurs = new Map();

function formateur(min, max) {
  const cle = `${min}-${max}`;
  if (!formateurs.has(cle)) {
    formateurs.set(cle, new Intl.NumberFormat("fr-FR", { minimumFractionDigits: min, maximumFractionDigits: max }));
  }
  return formateurs.get(cle);
}

/** Nombre à `decimales` décimales fixes (équivalent affiché de toFixed). */
export function nombreFR(valeur, decimales = 0) {
  const n = Number(valeur);
  return formateur(decimales, decimales).format(Number.isFinite(n) ? n : 0);
}

/** Nombre sans décimales imposées (jusqu'à `max`). */
export function entierFR(valeur, max = 2) {
  const n = Number(valeur);
  return formateur(0, max).format(Number.isFinite(n) ? n : 0);
}
